import { createFileRoute } from '@tanstack/react-router'
import { useLingui } from '@lingui/react/macro'
import { TakeABreakForm } from '@/features/take-a-break/take-a-break-form/take-a-break-form'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { AccessControlInfo } from '@/features/access-controls/access-control-info'
import { AccessControlType } from '@/features/access-controls/access-control-type'

export const Route = createFileRoute(
  '/_app/your-play/access-controls/take-a-break',
)({
  component: AccessControlSelect,
})

function AccessControlSelect() {
  const { t } = useLingui()

  return (
    <TertiaryPageLayout
      headerText={t`Take a Break`}
      infoDrawerContent={
        <AccessControlInfo selectedTab={AccessControlType.TAKE_A_BREAK} />
      }
    >
      <TakeABreakForm />
    </TertiaryPageLayout>
  )
}
